import { Injectable } from '@angular/core';
import { BdbRequestService } from './bdb-request.service';
import { RequestInfo } from '../models/request-info.model';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { environment } from '../../../environments/environment';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { IAbstentionListRequestBody } from './models/bdb-iabstention-list-body';
import { IReportDataDto } from './models/IReportDataDto';
import { ResponseFromFetch } from '../models/response-from-fetch.model';

@Injectable()
export class BdbAbstentionService {

    constructor(
        private readonly bdbSessionStorageService: BdbSessionStrgService,
        private readonly bdbRequestService: BdbRequestService,
    ) {
    }

    public checkAbstentionList(): Promise<boolean> {
        if (environment.enableCheckAbstentionListIAC) {
            return this.checkAbstentionListIAC()
        } else {
            return this.checkAbstentionListNOIAC()
        }
    }

    public checkAbstentionListIAC(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            resolve(true)
        });

    }

    public checkAbstentionListNOIAC(): Promise<boolean> {
        const uuidAuth = this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH);
        const url = `${environment.authManagerV2EndpointSandbox}/V1/product/authenticator/abstention-list`;
        console.log('uuidAuth', uuidAuth);
        const requestInfo: RequestInfo = {
            body: this.getAbstentionListBody(),
            headers: this.getAbstentionListHeaders()
        };
        return new Promise<boolean>((resolve) => {
            this.bdbRequestService.requestPostSandbox(url, uuidAuth, requestInfo).then((response: ResponseFromFetch) => {
                const isAllowedToContinue = response.status === 200;
                resolve(isAllowedToContinue);
            }).catch((reason) => {
                console.error('Error checking abstention List', reason);
                resolve(false)
            });
        });
    }

    private getAbstentionListBody(): IAbstentionListRequestBody {
        const uuidAuth = this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH);
        const identityNumber = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const identityType = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE) || 'CC';
        return {
            identityNumber,
            identityType,
            reportData: this.getReportData(),
            uuidAuth
        };
    }

    private getReportData(): IReportDataDto {
        const branch = this.bdbSessionStorageService.get(SessionStorageKeysEnum.BRANCH) || '';
        const cellPhone = this.bdbSessionStorageService.get(SessionStorageKeysEnum.CELL_PHONE) || '';
        const privateIp = this.bdbSessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP) || '';
        const specificProductInfoUuid = this.bdbSessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID) || '';
        const sellerIdentityType = this.bdbSessionStorageService.get('sellerIdentityNumberLdap') || '';
        const sellerDocumentNumber = this.bdbSessionStorageService.get('sellerIdentityNumberLdap') || '';
        const sellerUsername = this.bdbSessionStorageService.get('sellerUsername') || '';
        const sellerIdentityNumberLdap = this.bdbSessionStorageService.get('sellerIdentityNumberLdap') || '';
        const branchOffice = this.bdbSessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE) || '';
        const idUserMdm = this.bdbSessionStorageService.get('user') || '';
        const mediumType = this.bdbSessionStorageService.get('mediumType') || '';
        const latitud = this.bdbSessionStorageService.get('latitude') || '';
        const longitud = this.bdbSessionStorageService.get('longitude') || '';
        return {
            branch,
            cellPhone,
            privateIp,
            specificProductInfoUuid,
            branchOffice,
            idUserMdm,
            mediumType,
            sellerIdentityType,
            sellerDocumentNumber,
            sellerUsername,
            sellerIdentityNumberLdap,
            latitud,
            longitud
        };
    }

    private getAbstentionListHeaders() {
        return {
            'X-Channel': this.bdbSessionStorageService.get(SessionStorageKeysEnum.MEDIUM_TYPE),
            'Content-type': 'application/json',
            'X-Product': this.bdbSessionStorageService.get(SessionStorageKeysEnum.SITE),
            'X-IPAddr': this.bdbSessionStorageService.get(SessionStorageKeysEnum.PUBLIC_IP),
            'X-RqUID': this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH)
        };
    }

    getSellerUsername(mediumType: string): string {
        if (mediumType === '3') {
            return this.bdbSessionStorageService.get('sellerUsername');
        } else if (mediumType === '1') {
            return 'AlliedForLivenessAndRecognition'
        } else {
            return '';
        }
    }

    getSellerIdNumberLdap(mediumType: string): string {
        if (mediumType === '3') {
            return this.bdbSessionStorageService.get('sellerIdentityNumberLdap');
        } else if (mediumType === '1') {
            return 'AlliedForLivenessAndRecognition'
        } else {
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/bdb-abstention.service.ts